import script from "./deposit.vue?vue&type=script&setup=true&lang=js"
export * from "./deposit.vue?vue&type=script&setup=true&lang=js"

import "./deposit.vue?vue&type=style&index=0&id=2c263ef1&lang=scss&scoped=true"
import "./deposit.vue?vue&type=style&index=1&id=2c263ef1&lang=scss&scoped=true"
import "./deposit.vue?vue&type=style&index=2&id=2c263ef1&scoped=true&lang=scss"
import "./deposit.vue?vue&type=style&index=3&id=2c263ef1&lang=scss&scoped=true"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c263ef1"]])

export default __exports__